import { FolderOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EmptyStateWithError } from "@/lib/components/errors";
import { useServicesDialogs } from "../../hooks/use-services-dialogs";
import { useServicesUIStore } from "../../store/use-services-ui-store";

interface ServicesEmptyStateProps {
  totalCategories: number;
}

export function ServicesEmptyState({ totalCategories }: ServicesEmptyStateProps) {
  const { setSearchTerm } = useServicesUIStore();
  const { handleCreateCategory, handleCreateService } = useServicesDialogs();

  const isNoData = totalCategories === 0;

  const title = isNoData ? "No service categories yet" : "No results found";

  const description = isNoData
    ? "Create your first category to start organizing your services."
    : "Try adjusting your search terms or create a new service.";

  const actionButton = isNoData ? (
    <Button onClick={handleCreateCategory}>
      <FolderOpen className="w-4 h-4 mr-2" />
      Create First Category
    </Button>
  ) : (
    <div className="flex justify-center gap-2">
      <Button variant="outline" onClick={() => setSearchTerm("")}>
        Clear Search
      </Button>
      <Button onClick={() => handleCreateService()}>Create Service</Button>
    </div>
  );

  return (
    <EmptyStateWithError
      title={title}
      description={description}
      error={null}
      actionButton={actionButton}
    />
  );
}
